export default "__VITE_ASSET__DnENVOyQ__"